//Lenovo Parts FlexiGrid

//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';
import FlexiGrid from '../common/FlexiGrid/FlexiGrid';

//Doublecheck everything below this line. All from old boilerplate table.
import { useLocation, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

//Contexts
import { AppContext } from "../Auth/contexts/AppContext"

//CSS Styles
//import { useTheme } from '@mui/material/styles'; //Only if needed. Access theme variables with: const theme = useTheme(); Add custom properties to theme in ui/theme/index.js.
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';

//Datetime formatting
import dayjs from 'dayjs'; //Used with new datetimepickers

//MaterialUI
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

//Icons for Custom Buttons:
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Select } from '@mui/material';

//NNNNNNNNNNNNN-NON-STANDARD IMPORTS-SSSSSS-SSS
//Additional Libraries Specific to XYZ FlexiGrid goes below this line. Just so long as FlexiGrid and the above are being kept tidy, we're in good shape.
import UploadFileIcon from '@mui/icons-material/UploadFile';
//This controller can upload to DB Lenovo Part Data!
import axios from "axios";

var dbendpoint = process.env.REACT_APP_DB_API4;

//Default Axios Post Options
const defaultpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 11800,
};

//Long Axios Post Options
const longpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 120000,
};


//Functional Controller
const LenovoPartsFlexiGrid = () => {
	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	/* App Context - Allows userPerms, userRole, and others to be used*/
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;

	/* ##########################  DATA MUTATION  ########################## */
	//   This function allows us to mutate data after it is received from the database, but before it is rendered on the grid or exported.
	const MutateData = (dbdata) => {
		//Mutate each item in dbdata as needed.
		for (var i=0; i<dbdata.length; i++){
			//Example: Add Margin calculation
			dbdata[i]["NewMargin"] = (parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])).toFixed(2);
		}
		return dbdata;
	}
	//An example of mutation specifically for exports. This allows you to have different data shown on screen vs exported.
	const ExportMutateData = (dbdata) => {
		//Mutate each item in dbdata as needed.
		for (var i=0; i<dbdata.length; i++){
			//Example: Add Margin calculation
			dbdata[i]["NewNewMargin"] = (parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])+500).toFixed(2);
		}
		return dbdata;
	}


	/* ##########################  EXPANDED ROW RENDER  ########################## */
	//   This controls how a bonus row is rendered on ExpandRow! Enable bonus row with configuration.expandedrow = true.
	const ExpandedRowRender = ({ localstate, index, classes, UpdateState }) => {
		//console.log(localstate);
		//Bonus row is rendered just inside <tr><tr>
		//With access to index, localstate, and UpdateState, you can make this to powerful things!
		return (
			<td colSpan={localstate.configuration.columns.filter(col=>col.visible).length} style={{ backgroundColor: "#F9F9F9", borderTop: "0px", padding: "10px 15px 10px 15px" }}>
				Full Width Example. 
			</td>
		)
	}

	/* ##########################  CUSTOM FUNCTIONS  ########################## */
	const modelButtons = ({ localstate, index, column, classes, UpdateState, ExpandRowToggle }) => {
		const models = localstate.griditems[index]["LenovoModelsArray"] || [];
	  
		return (
		  <td
			style={column.cellstyle}
			className={classes.flexigridcustomcontainer}
		  >
			{models.length > 0 && (
			  <>
				{models.map((model, i) => {
				  const query = `Lenovo ${model}`;
				  const href = `https://www.google.com/search?q=${encodeURIComponent(query)}`;
	  
				  return (
					<React.Fragment key={i}>
					  <a href={href} target="_blank" rel="noopener noreferrer">
						{model}
					  </a>
					  {i < models.length - 1 && " "}
					</React.Fragment>
				  );
				})}
			  </>
			)}
		  </td>
		);
	  };

	const BulkMutatorBtn = ({ localstate, index, column, classes, UpdateState }) => {
		const ApplyBulkMutation = (localstate, UpdateState) => {
			for (var i=0; i<localstate.griditems.length; i++){
				localstate.griditems[i].Price = 666; //Or do some calculation based the current griditems values. 
			}
			UpdateState(localstate);
		}
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			> 
				<span style={{ fontWeight: "bold", color: "blue" }}>
					<Button
						className={classes.bluebtn}
						style={{ margin: "0px", padding: "1px 1px 1px 1px", fontSize:"10px" }}
						color="primary" variant="contained"
						onClick={() => ApplyBulkMutation(localstate, UpdateState)}>
						Bulk Mutate Price
					</Button>
				</span>
			</td>
		);
	}; 

	//Since button.fileinput is true, this is kind of a placeholder.
	const UploadData = ({localstate, UpdateState}) =>{
	}

	//This function is set to Flexigrid to be used when the file is uploaded.
	const handleFileChange = ({event, incrementPass, incrementFail, setErrorTimeout, localstate, UpdateState, dispatch, newStatus, setStatusTimeout}) =>{
		const file = event.target.files[0];
		// Process file...
		if (!file) return;
		ProcessFile(file, dispatch, newStatus, incrementPass, incrementFail, setErrorTimeout,);
	
	  };

	  //A Ref stays consistent throughout async function
	const requestcount = useRef(0);

	  const ProcessFile = async (file, dispatch, newStatus, incrementPass, incrementFail, setErrorTimeout,) => {
		//Configuration
		requestcount.current = 0;
		var timeout = 3000; //Seconds before closing final ProgressBar results - To Do: Add option to NOT timeout at all
		var requestinterval = 250; //Milliseconds

		const reader = new FileReader();
		
		//console.log(file);

		reader.onload = async (e) => {
		  try {
			const raw = JSON.parse(e.target.result);
			//console.log('Parsed JSON root:', raw);

			// Adjust this according to actual structure
			var isarray = Array.isArray(raw);


			var updatearray = Array.isArray(raw) ? raw : raw.list || raw.data || [];
			
			//console.log('File loaded, processing', updatearray.length, 'items...');

	
			if (updatearray.length > 0) {
				//DisableButtons();
				dispatch(newStatus({
					type: "progress",
					msg: 'Saving items...',
					show: true,
					settimeout: true, //This option allows for a timeout after the final item is pass/failed
					timeout: timeout, //Initiated on final item 
					itemtype: 'items', //Labels your save types such as items, products, skus, parts
					finished: 0,
					percent: "0%",
					total: updatearray.length,
					pass: 0,
					fail: 0,
					faillist: [], //Can take simple values,
					faillinks: [], //Can take links to things like items or products.
					timeoutid: false,
					errors: [] //Can take strings
				}));
				var i = 0;
				var limit = updatearray.length - 1;
				/* INTERVAL */
				var updateitems = setInterval(function () {
					var item = updatearray[i];

					// Transform data to match your Laravel structure
					const postdata = {
						dbmodel:"flexlenovopart",
						itemskey:"ID",
						uniquekey:"LenovoPartID", //This is used to check for duplicates in the database. If a duplicate is found, it updates instead of creating a new entry. Make sure to adjust this to your needs and DB structure. Can be a single value or an array of values.
						updateinstead:true, //This is a special allowance to simply update the record. Doublecheck perms for update!
						item:{
							ID:uuidv4(),
							LenovoPartID: item.id,
							Name: item.name,
							LenovoModelsArray: item.products, // This is a Lenovo Driven value. Holds an array of Lenovo Product Types like 20UE, 30AE, etc.
							Price: item.salability?.includingDiscountValue || 0,
							Discount:item.salability?.discount || 0,
							Clearance: item.salability?.clearance || false,
							Stock: item.salability?.stock || 0,
							BacCode: item.bacCode,
							Commodity: item.commodityVal,
							ImageUrls: item.imageUrls,
							substitutes: item.substitutes,
							PendingItem:1
						}
					 
					};

				
					axios.post(dbendpoint+"/flexigrid/update", postdata, longpostoptions).then(res => {
						//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
						if (res.status === 200) {
							//If ValidateUser() fails to verify user, it sends back 'login' error. 
							if (res.data.Status === "login") {
								//Not logged in. Reload page causes redirect to /login
								window.location.reload(false);
							}
							if (res.data.Status === "Success") {
								// //Success response also includes the item!
								// //Try: 10-20-2023 - Should we access read-only DOM elements such CreatedBy? When we do an update, we're avoiding a reload of DB and rerender already..... This would be the icing on the cake even just for static items.
								// //If we sent new rows, we'll need to reference the old ID.
								// var itemindex = 0;
								// if (res.data.OldID) {
								// 	itemindex = localstate.griditems.map(function (o) { return o.ID; }).indexOf(res.data.OldID);
								// 	localstate.griditems[itemindex].unsaved = false;
								// 	rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.unsavedhighlight);
								// 	rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.errorhighlight);
								// 	//Set New ID
								// 	localstate.griditems[itemindex].ID = res.data.item.ID;
								// } else {
								// 	itemindex = localstate.griditems.map(function (o) { return o.ID; }).indexOf(res.data.item.ID);
								// 	localstate.griditems[itemindex].unsaved = false;
								// 	//Refs allow us to update the grid live!
								// 	rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.unsavedhighlight);
								// 	rowRefs.current[itemindex + 'SaveStatus'].classList.remove(classes.errorhighlight);
								// }
								dispatch(incrementPass());
							}
							if (res.data.Status === "Failure") {
								//Failure error - To Do: Dispatch failure messages to the ProgressBar
								dispatch(incrementFail(res.data.message));
							}
							requestcount.current++;
							//FinalizeRequest(requestcount.current, limit, timeout);
	
						} else {
							//Non-200 message from server.
							requestcount.current++;
							//FinalizeRequest(requestcount.current, limit, timeout);
							dispatch(incrementFail("Non-200 response."));
						}
					}).catch(err => {
						//Non-200, 500 Error, timeout?
						//console.log(err);
						requestcount.current++;
						//FinalizeRequest(requestcount.current, limit, timeout);
						dispatch(incrementFail("500 response."));
					});
					//If we have looped through all items, clear this interval.
					if (i === limit) {
						clearInterval(updateitems);
					}
					i++;
				}, requestinterval);
			} else {
				dispatch(newStatus({
					type: "warning",
					msg: 'Nothing to process.',
					show: true,
					settimeout: true, //This option allows for a timeout after the final item is pass/failed
					timeout: 10, //Initiated on final item 
					itemtype: 'items', //Labels your save types such as items, products, skus, parts
					finished: 0,
					percent: "0%",
					total: 5,
					pass: 0,
					fail: 0,
					faillist: [], //Can take simple values,
					faillinks: [], //Can take links to things like items or products.
					timeoutid: false,
					errors: [] //Can take strings
				}));
				dispatch(setErrorTimeout(5));
				//ResetPendingSaves();
			}




			//   try {
			// 	const response = await axios.post('/lenovo-parts', payload);
			// 	dispatch(incrementPass());
			// 	console.log(`Item ${i + 1}/${jsonData.length} uploaded:`, item.id);
			//   } catch (error) {
			// 	console.error(`Error uploading item ${item.id}:`, error);
			// 	// Continue with next item even if one fails
			//   }
			
			
			
			
		  } catch (error) {
			console.error('Invalid JSON file:', error);
			alert('Error: Invalid JSON file');
		  }
		};
		
		reader.readAsText(file);
	  };
	

	/* ##########################  CUSTOM ON-CHANGE FUNCTIONS  ########################## */
	//   Custom for onChange of items in edit mode. See reference to this function in the Cost column. Bear in mind, Cost itself is handled with validation positivedecimal2
	const onChangeCost = ({localstate, index, column, rowRefs}) => {
		rowRefs.current[index+"Margin"].textContent = localstate.griditems[index]["Margin"] = (parseFloat(localstate.griditems[index]["Price"]) - parseFloat(localstate.griditems[index]["Cost"])).toFixed(2);
	}

	/* ##########################  SEARCH INPUT DEFAULTS  ########################## */
	//   These establish the baseline for the page search inputs.
	//   Container and Key Sizes for Search Inputs
	const containersizes = "260px";
	const keysizes = "180px";

	//  Make sure to update defaultselectinputs as well to use your inputs. Named properties of inputdefaults must match to a 'value' in defaultselectinputs or else the input text will not render correctly.
	var inputdefaults = { 
		Name: {
			type: "Name",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		LenovoPartID: {
			type: "LenovoPartID",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		LenovoModelsArray:{
			type: "LenovoModelsArray",
			value:"",
			mode:"like",
			searchhandler:"lenovomodelsarray",
			orable:true,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		'Price >': {
			type: "Price >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'Price <': {
			type: "Price <",
			value: "",
			mode: "lessthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'Stock >': {
			type: "Stock >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'Discount >': {
			type: "Discount >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		Clearance: {
			type: "Clearance",
			value: "",
			mode: "bool",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		Demand: {
			type: "Demand",
			value: [],
			mode: "select",
			orable: true,
			//Select Menu Items:
			menuitems: [
				{
					value: 0,
					key: uuidv4(),
					text: "Unknown",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Unknown",
					chipclass: classes.gradebad, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: 1,
					key: uuidv4(),
					text: "Not Needed",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Not Needed",
					chipclass: classes.gradebad, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: 2,
					key: uuidv4(),
					text: "Rarely Needed",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Rarely Needed",
					chipclass: classes.gradec, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: 3,
					key: uuidv4(),
					text: "Sometimes Needed",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Sometimes Needed",
					chipclass: classes.gradeb, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: 4,
					key: uuidv4(),
					text: "Actively Seeking",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Actively Seeking",
					chipclass: classes.gradea, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
			],
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			//Experimental Multiple!
			multiple: true,//Change 'value' to array if true.
			center: true,
			grow: 1,
			usechips: true
		},
		Note: {
			type: "Note",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},






		// //Products AutoComplete - Autocompletes are always or-able
		// //For this demo, ProductID is a direct column on the basictable. However a lot of tables will need this to search a nested relationship which will require a 
		// //custom query to go with it. In that case, add a searchhandler value to direct FlexiGridController to your custom DB search function.
		// products: {
		// 	type: "products",
		// 	keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
		// 	searchkey: "Name", //This is the column we are searching from the table
		// 	//searchhandler:"ordersproducts",
		// 	value: [],
		// 	multiple: true,
		// 	//inputValue:"", //Text Search! This *CAN* be used... but seems nicer without it!
		// 	mode: "autocomplete",
		// 	orable: true,
		// 	defaultsearchterm: "70",
		// 	limit: 10, //Database return limit, keep below ~100
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// 	debouncetime: 0 //Not a lot of typing or results.
		// },
		// NotName: {
		// 	type: "NotName",
		// 	value: "",
		// 	mode: "not", //Nots may need to be added to FlexiGridSearchTools for non-orable.
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Standard DateTimeAfter
		// DateTimeAfter: {
		// 	type: "DateTimeAfter",
		// 	value: (() => {
		// 		//Set to 10 years ago (or else you probably won't get any data)
		// 		return dayjs().subtract(10, 'years');

		// 	})(),
		// 	mode: "datetimeafter",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Standard DateTimeBefore
		// DateTimeBefore: {
		// 	type: "DateTimeBefore",
		// 	value: dayjs(), //new Date, 
		// 	mode: "datetimebefore",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Example AutoComplete - Components can take optional "producttype" to narrow between product types.
		// components: {
		// 	type: "components",
		// 	keyedby: "ID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
		// 	searchkey: "Name", //This is the column we are searching from the table
		// 	producttype: "Desktop",
		// 	value: [],
		// 	mode: "autocomplete",
		// 	orable: true,
		// 	defaultsearchterm: "",
		// 	limit: 10, //Database return limit, keep below ~100
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// 'Cost >': {
		// 	type: "Cost >",
		// 	value: "",
		// 	mode: "greaterthan",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// 'Cost <': {
		// 	type: "Cost <",
		// 	value: "",
		// 	mode: "lessthan",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Instead of Checkbox, this is Bool example. "yes, no, and - "
		// NewCheckbox: {
		// 	type: "NewCheckbox",
		// 	value: "",
		// 	mode: "bool",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// NameStrict: {
		// 	type: "Name",
		// 	value: "",
		// 	mode: "strict",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// SomeSelectable: {
		// 	type: "SomeSelectable",
		// 	value: [],
		// 	mode: "select",
		// 	orable: true,
		// 	//Select Menu Items:
		// 	menuitems: [
		// 		{
		// 			value: "",
		// 			key: uuidv4(),
		// 			text: "-",
		// 			usechip: false
		// 		},
		// 		{
		// 			value: 10,
		// 			key: uuidv4(),
		// 			text: "Ten (integer)",
		// 			usechip: false
		// 		},
		// 		{
		// 			value: "A",
		// 			key: uuidv4(),
		// 			text: "A",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Grade A",
		// 			chipclass: classes.gradea, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "B",
		// 			key: uuidv4(),
		// 			text: "B",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Grade B",
		// 			chipclass: classes.gradeb, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "C",
		// 			key: uuidv4(),
		// 			text: "C",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Grade C",
		// 			chipclass: classes.gradec, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "Bad",
		// 			key: uuidv4(),
		// 			text: "Bad",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Bad",
		// 			chipclass: classes.gradebad, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "Repair",
		// 			key: uuidv4(),
		// 			text: "Repair",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Repair",
		// 			chipclass: classes.graderepair, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "Scrap",
		// 			key: uuidv4(),
		// 			text: "Scrap",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Scrap",
		// 			chipclass: classes.gradeb, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 	],
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	//Experimental Multiple!
		// 	multiple: true,//Change 'value' to array if true.
		// 	center: true,
		// 	grow: 1,
		// 	usechips: true
		// },
	};

	/* ########################## Custom Parameters: Modify Per-Controller  ##########################

	 Each new table will likey have very different parameters. Handle them before configuration.

	Concept: We have this really complicated search input system. When a page is linked with URL parameters, let's marshall each 
	key-value pair into new defaults based on input defaults.

	Possibly clear the URL before rendering inputs and page?

				*/

	//This controls how many inputs we need to fill for the page. Often we simply use 4 or 8, but we'll try and modify the code to be able to use any values.
	const minimuminputs = 4;
	const maximuminputs = 8;		

	

	
	const params = new URLSearchParams(useLocation().search);

	const urlparams = Array.from(params.entries());


	//		AUTOCOMPLETEPAIRS
	//		If you are not using auto-complete search inputs, you may simply comment the array inside autocompletepairs.
	// 		This is a special array. It is structured to allow a key-value pair shortcut to pre-fill a search input with label!
	//		Logic below also removes the need to add the search input type - when an autocomplete pair is found our custom array's third argument allows us to understand the search input type!
	//		Database compatibility: Autocompletes are typically driven by the searchinputtype as well, see DBAutoComplete.php
	// 		URL Params Compatiblity: Any link generator will need to follow the pattern of the autocompletepair. In this example, ProductID then Name and always in that order.
	// 
	// 
	// 		The structure of the array of arrays is:
	//		----------------------------------------------------------------------------------------------------------------------------------------------------------------------
	//		keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection. This is often how the DB will load the items.
	//		searchkey: "Name", //This is the column we are searching from the table, often a friendly name
	//		searchinputtype:  The searchinput that we're pre-filling. Having this assigned means we won't ever need to reference it as a URL parameter!
	//		[[keyedby, searchkey, searchinputtype],[keyedby, searchkey, searchinputtype],...]


	const autocompletepairs = [
		//['ProductID', 'Name', 'products'], //This will not only fetch from the DB correctly, but it will render the current value without a DB call!
		//DBKey, Named Item, Autocomplete System
		//More Entries...
	]

	const configuredinputs = []; //This is where we'll hold 
	var currentconfiguration = {}; 
	var combine = false;
	var simpleparam = true; //Values like OrderID, Name, Date.... no need for key-value input.
	//This itterates the parameters in sequential order. We need to have flags to check for pairs...
	for (let i = 0; i < urlparams.length; i++) {
		//Assume simpleparam until false:
		simpleparam = true;
		//console.log("Checking: "+urlparams[i][0]+"="+urlparams[i][1]);
		//With urlparams, 0 is the key, and 1 is the value.
		//Use current entry and check that it is or isn't an auto-complete pair
		for (let j=0; j<autocompletepairs.length; j++){
			if (urlparams[i][0]===autocompletepairs[j][0]){
				//Doublecheck for next value!
				if (urlparams[i+1] && urlparams[i+1][0]===autocompletepairs[j][1]){
					//console.log("Autocomplete Pair found: "+urlparams[i][0]+" and "+urlparams[i+1][0]);
					//Assume from here, we can digest the values and no longer process this as a simple parameter:
					simpleparam = false;
					currentconfiguration = Object.assign({}, inputdefaults[autocompletepairs[j][2]]); //Source must exist above. This example, we're cloning the 'products' search input.
					//This example is interpereted as : currentconfiguration = Object.assign({}, inputdefaults['products']);
					
					//Check if we should add our new configuration to an existing one.
					combine=false;
					for (var p=0;p<configuredinputs.length; p++){
						//console.log(configuredinputs);
						//console.log(currentconfiguration);
						if (configuredinputs[p].type===currentconfiguration.type){
							combine = true;
							//Modify existing configured input
							configuredinputs[p].value.push({
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							})
						}
					}

					if (!combine){
						//Override value:
						currentconfiguration.value = [
							{
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							}
						];
						//Push to configured inputs
						configuredinputs.push(currentconfiguration);
					}
					//console.log("Autocomplete found for: "+autocompletepairs[j][2]);
					//Since we consumed the second half of the URL parameter for the autocomplete, we skip the next URL entry!
					i++;
				}
			}
		}

		//If simpleparam is still true, we can handle it as a normal input:
		if (simpleparam){
			//Check that the parameter exists in inputdefaults:
			if (inputdefaults[urlparams[i][0]]){
				currentconfiguration = Object.assign({}, inputdefaults[urlparams[i][0]]);
				currentconfiguration.value = urlparams[i][1];
				//console.log(currentconfiguration);
				//Push to configured inputs
				configuredinputs.push(currentconfiguration);
			}
		}
	}

	//If configured inputs is less than the minimum, we need to fill the remainder with appropriately available search inputs, 
	//preset to commonly used ones that aren't already specified in URL parameters!
	//If we need a quick-start, simply set an array like ["Name","Name","Name","Name"] - we need enough to fill the minimum inputs required.
	//First we'll need a search input priority array:
	var priorityarray = [
		"Name",
		"LenovoPartID",
		"Note",
		"Price <",
		//"ProductArray",
		"Price >",
		"Stock >",
		"Clearance",
		"Demand",
		"Discount >",
		"Stock <",
	];

	//Make a copy of this array so we can use it for resets!
	var resetarray = Object.assign({}, priorityarray);

	var k=0;
	var l=0;
	var finalinputs=[]; //Configure a variable to send to configuration!
	if (configuredinputs.length < minimuminputs){
		for (var k=0; k<configuredinputs.length; k++){
			finalinputs.push(configuredinputs[k]);
			//Loop configured inputs and remove any priority items that are already handled!
			for (var m=0; m<priorityarray.length; m++){
				if (configuredinputs[k].type===priorityarray[m]){
					priorityarray.splice(m,1);
				}
			}
		}
	}

	//We can now itterate over the other priority inputs and fill in the next most important ones that weren't already sliced off the array.
	for (k=0; k<priorityarray.length; k++){
		finalinputs.push(inputdefaults[priorityarray[k]]);
	}
	//Debug:
	//console.log("Final Inputs:");
	//console.log(finalinputs);


	/* ##########################  Configuration Section  ########################## */
	//Perms - Be sure endpoints are secure because this certainly isn't. These are for perm driven views, not the perms on data.
	var perms = {
		createPerm:(userPerms['createLenovoPart']===1 ? true : false),
		readPerm:(userPerms['readLenovoPart']===1 ? true : false),
		updatePerm:(userPerms['updateLenovoPart']===1 ? true : false),
		deletePerm:(userPerms['deleteLenovoPart']===1 ? true : false),
	}



	//Grid Configuration
	const configuration = {
		//PAGE OPTIONS
		showtitle:true,
		title: "Lenovo Parts",
		menuitem:"/lenovoparts",
		menusection:"Martin's Section",
		viewmode:"grid", //Default is "grid" to show grid mode. 
		 
		//DATA OPTIONS
		apiendpoint: "/flexigrid/",
		dbmodel:"flexlenovopart", //or flexproduct, flexorder, etc	
		itemskey:"ID", //No valid item key needed when PendingItem=1 and user is able to create.
		dupescheck:["LenovoPartID"], //Checks for duplicates based on this key or array of keys when creating new items. 
		nestedrelationships:[
			'creationuser', //CreatedByUserID
			'updateuser',	//UpdatedByUserID
			'deletionuser', //DeletedByUserID
			//'product'
		],
		newitemviewurlprefix: "/lenovopart/", //When clicking 'ADD ITEM' button, goes to this url with the ID of created item.
		//Mutations: Useful for derived values such as FullName or TotalCharges. They are calculated client-side after data load and can be used for view or exports.
		//Fn or null.
		mutatedata:MutateData,
		exportmutatedata:ExportMutateData,


		//DB Support items (try to add supports to DB tables when it's helpful)
		softdeletesupport:true,
		creationusersupport:true,
		updateusersupport:true,
		deleteusersupport:true,

		//Datetimes to handle
		datetimes:[
			'created_at',
			'updated_at',
			//'DateTime',
		],


		//TABLE OPTIONS
		tablebordertype: "thin", //open (no borders like on Products), thin (Main tables, darker border), thick (Order Details has all thick and lighter gray border tables)
		showcolumnheaders:true,
		maxrowseditmode:100,
		statusbar:true,
		expandedrow:false,
		expandedrowrender:ExpandedRowRender, //Required function to be used inside bonus row <tr></tr> if ExpandRow=true
		minimuminputs:4,
		maximuminputs:8,
		rowsperpage:100,
		rowsperpageoptions:[100, 250, 500],



		//Search Input Settings
		//Check that each one of these coincides with a 'type' in inputdefaults 
		defaultselectinputs: [
			{ value: "Name", text: "Part Name" },
			{ value: "LenovoPartID", text: "Part ID" },
			{ value: "Note", text: "Note" },
			{ value: "Price <", text: "Price <" },
			//{ value: "ProductArray", text: "Product Name" }, //explain: LONGTEXT json array of [ProductID(s), and Name(s)]. Easier than keeping yet-another-table
			{ value: "LenovoModelsArray", text: "Lenovo Model" }, //explain: LONGTEXT json array of models ["20EG", "82GH", etc]. Easier than keeping yet-another-table
			{ value: "Demand", text: "Demand" },
			{ value: "Stock >", text: "Stock >" },
			{ value: "Clearance", text: "Clearance" },
			{ value: "Discount >", text: "Discount >" },
			{ value: "Stock <", text: "Stock <" },
			{ value: "Price >", text: "Price >" },
		],
	

		//Keep a copy of the default inputs just in case the user wants to "reset" the page
		inputdefaults:inputdefaults, //ToDo: Change this to final inputs!
		resetarray:resetarray,
		//Send a copy of configuredinputs
		configuredinputs:finalinputs,

		//Search by & order
		orderby: "Demand",
		order: "desc",


		/* ##########################  Columns Section  ########################## */
		//Columns describe the renderable columns
		//Header styles only respect width and not maxWidth or minWidth because tableLayout:"fixed" on flexigrid. Without fixed table layout, inner Grids won't ever size correctly.
		//Set these widiths carefully, and narrow on what you can.
		columns: [
			{
				field: "Checkbox",
				visible: true,
				columnheader: "maincheckbox",
				currentlyeditable:true,
				render: "maincheckbox", //Special, does not need extended config
				borders:"all",
				columnoption:false,
				columnoptionlabel:"Checkbox"

			},
			{
				field: "Name", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Part Name",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"350px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:10, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Part Name"
			},
			{
				field: "LenovoPartID", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Part ID",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"160px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:10, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Part ID"
			},
			{
				field: "Models",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Models",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"center", //This can help also anchor any children, even buttons
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				render: "customelement",
				customelement:modelButtons,
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Lenovo Models"
			},
			{
				field: "Price",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Price",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"70px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				//maxvalue:, //Not needed for some validations.
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Price"
			},
			{
				field: "TargetPrice",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "TargetPrice",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"70px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				//maxvalue:, //Not needed for some validations.
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"TargetPrice"
			},
			{
				field: "Stock",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Stock",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"60px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positiveinteger", // "text", "positiveinteger", "positivedecimal2"
				//maxvalue:, //Not needed for some validations.
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Stock"
			},
			{
				field: "Note", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Note",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"400px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:10, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Note"
			},
			{
				field: "Demand",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Demand",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"140px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"select", 
				render: "select", //Requires Selections:
				selectoptions:[
					{value:0, text:"Unknown", useCustomOption:true, customOption:()=>{return <MenuItem value={0}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#505050", padding:"2px 5px 0px 5px"}}>Unknown</div></MenuItem>;}},
					{value:1, text:"Not Needed", useCustomOption:true, customOption:()=>{return <MenuItem value={1}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#808080", padding:"2px 5px 0px 5px"}}>Not Needed</div></MenuItem>;}},
					{value:2, text:"Rarely Needed", useCustomOption:true, customOption:()=>{return <MenuItem value={2}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#CE823E", padding:"2px 5px 0px 5px"}}>Rarely Needed</div></MenuItem>;}},
					{value:3, text:"Sometimes Needed", useCustomOption:true, customOption:()=>{return <MenuItem value={3}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#CCB136", padding:"2px 5px 0px 5px"}}>Sometimes Needed</div></MenuItem>;}},
					{value:4, text:"Actively Seeking", useCustomOption:true, customOption:()=>{return <MenuItem value={4}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#45B84A", padding:"2px 5px 0px 5px"}}>Actively Seeking</div></MenuItem>;}},
				
				],
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Some Select"
			},
			{
				field: "Discount",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Disc",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"55px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				//maxvalue:, //Not needed for some validations.
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Discount"
			},
			{
				field: "updated_at",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Last Update",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"140px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				render: "datetime",
				datetimeformat:"short", //"friendly",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Last Update"
			},
			{
				field: "created_at",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Created",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"140px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				render: "datetime",
				datetimeformat:"short", //"friendly",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Creation Date"
			},
			

		],

		//Controls how edit mode will traverse editable cells.
		taborder:["TargetPrice", "Note"],

		// buttonsold:{
		// 	Save:{
		// 		visible:true
		// 	},
		// 	PendingSave:{
		// 		visible:true
		// 	},
		// 	AddRow:{
		// 		visible:true
		// 	},
		// 	AddItem:{
		// 		visible:true
		// 	},
		// 	ViewOptions:{
		// 		visible:true
		// 	}
		// }

		/* ##########################  Buttons Section  ########################## */
		buttons: [
			{
				type:"Save",
				text:"Save",
				visible:true,
				perm:(userPerms['updateLenovoPart']===1 ? true : false)
			},{
				type:"PendingSave",
				text:"Save",
				visible:true,
				perm:(userPerms['updateLenovoPart']===1 ? true : false)
			},{
				type:"AddRow",
				text:"Add Row",
				visible:false,
				perm:(userPerms['createLenovoPart']===1 ? true : false)
			},{
				type:"AddItem",
				text:"Add Item",
				visible:false,
				perm:(userPerms['createLenovoPart']===1 ? true : false)
			},{
				type:"ViewOptions",
				text:"View Options",
				visible:true,
				perm:true,
				config:{
					expandsearch:true,
					expandall:false,
					editmode:true
				}
			},{
				type:"EditItems",
				text:"Edit Items",
				visible:true,
				perm:(userPerms['updateLenovoPart']===1 ? true : false)
			},{
				type:"Export",
				text:"Export",
				visible:false,
				perm:true
			},{
				type:"ItemList",
				text:"Item List",
				visible:false,
				perm:true,
				title:"Item List",
				description: "Filter grid results by item <Name, ID, Sku, etc>.",
				itemlistkey:"Name"
			},{
				type:"Reset",
				text:"Reset",
				visible:true,
				perm:true
			},
			// SPECIAL PURPOSE BUTTONS, YOU MAY CONFIGURE THESE FOR YOUR NEEDS INCLUDING FUNCTIONS!
			// Name them as such: CustomButton1, CustomButton2, etc.
			{
				type:"CustomButton1",
				text:"Upload Data",
				visible:true,
				perm:true,
				icon:<UploadFileIcon sx={{
					color: "#222", fontSize: "1.2em", // match text size
					verticalAlign: "middle", // helps on some browsers
					display: "inline-block",
				}}>
				</UploadFileIcon>,
				fileinput:true,
				handleFileChange:handleFileChange,
				customfunction: UploadData
			}
		],

		bulkeditcolumns: [
			{
				field:"Note",
				label:"Note",
				changetype:"text",
				maxlength:200,
				minlength:3
			},
			{
				field:"Demand", 
				label:"Demand",
				changetype:"customselect",
				customoptions:[
							<MenuItem value={0}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#505050", padding: "2px 5px 0px 5px" }}>Unknown</div></MenuItem>,
							<MenuItem value={1}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#808080", padding: "2px 5px 0px 5px" }}>Not Needed</div></MenuItem>,
							<MenuItem value={2}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#CE823E", padding: "2px 5px 0px 5px" }}>Rarely Needed</div></MenuItem>,
							<MenuItem value={3}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#CCB136", padding: "2px 5px 0px 5px" }}>Sometimes Needed</div></MenuItem>,
							<MenuItem value={4}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45B84A", padding: "2px 5px 0px 5px" }}>Actively Seeking</div></MenuItem>,
					],
				defaultvalue:false,
			},{
				field:"DeleteItems",
				label:"Delete Items",
				changetype:"deleteitems"
			},
			// 	field:"Price",
			// 	label:"Price",
			// 	changetype:"float",
			// 	maxval:1000000000,
			// 	minval:0
			// },{
			// 	field:"PositiveInteger",
			// 	label:"Positive Integer",
			// 	changetype:"integer", //Positive Integer
			// 	maxval:1000000000,
			// 	minval:0
			// },{
			// 	field:"SomeBoolean", 
			// 	label:"Some Boolean",
			// 	changetype:"select",
			// 	menuitems:
			// 	[
			// 		{
			// 			value:0,
			// 			label:"No"
			// 		},{
			// 			value:1,
			// 			label:"Yes"
			// 		},{
			// 			value:null,
			// 			label:"Unknown (null, if capable)"
			// 		}
			// 	],
			// 	default:{
			// 		value:0,
			// 		label:"No"
			// 	},
			// },{
			// 	field:"NewCheckbox", 
			// 	label:"New Checkbox",
			// 	changetype:"checkbox", //Special bool to show checkbox
			// 	default:false,
			// },{
			// 	field:"Date", 
			// 	label:"Date",
			// 	changetype:"date", //Date
			// 	default:false, //Possibly send a default? "now"? "1yrago"? //For now false, no default.
			// },{
			// 	field:"DateTime", 
			// 	label:"Date Time",
			// 	changetype:"datetime", 
			// 	default:false,
			// },{
			// 	field:"SomeSelectable", 
			// 	label:"Some Selectable Custom",
			// 	changetype:"customselect",
			// 	customoptions:[
			// 		<MenuItem value={0}>
			// 					<em>Zero</em>
			// 				</MenuItem>,
			// 				<MenuItem value={null}>None - null</MenuItem>,
			// 				<MenuItem value="">Blank</MenuItem>,
			// 				<MenuItem value={10}>10</MenuItem>,
			// 				<MenuItem value={"Adam"}>
			// 					<div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Adam Taylor</div>
			// 				</MenuItem>,


			// 				<MenuItem value={"A"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Grade A</div></MenuItem>,
			// 				<MenuItem value={"B"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#ccb136", padding: "2px 5px 0px 5px" }}>Grade B</div></MenuItem>,
			// 				<MenuItem value={"C"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#ce823e", padding: "2px 5px 0px 5px" }}>Grade C</div></MenuItem>,
			// 				<MenuItem value={"Repair"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#e9523a", padding: "2px 5px 0px 5px" }}>Repair</div></MenuItem>,
			// 				<MenuItem value={"Scrap"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#777", padding: "2px 5px 0px 5px" }}>Scrap</div></MenuItem>,
			// 				<MenuItem value={"Unknown"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#999", padding: "2px 5px 0px 5px" }}>Unknown</div></MenuItem>,
			// 	],
			// 	defaultvalue:false,
			// },{
			// 	field:"ProductID",
			// 	label:"Product",
			// 	changetype:"autocomplete",
			// 	searchby:"Name",
			// 	searchtype:"products",
			// 	saveas:"ProductID",
			// 	optionkey:"ProductID", //Since field and saveas aren't always unique values, they're no good for keys we'd like to use from the DB
			// 	autocompletelimit:30,
			// 	debounce:1000,
			// 	childrelationship:true,
			// 	nestedmodel:"product",
			// 	defaultvalue:{
			// 		key:uuidv4(),
			// 		Name:"Default Product",
			// 		ProductID:0
			// 	}
			// },{
			// 	field:"DateTime", 
			// 	label:"Date Time",
			// 	changetype:"datetime",
			// 	defaultvalue:new dayjs(),
			// },{
			// 	field:"DeleteItems",
			// 	label:"Delete Items",
			// 	changetype:"deleteitems"
			// }

		],

		exportoptions:{
			limit:10000,
			exportmessage: "Exports of search results will be limited to your selection or the first "+10000+" rows of your current search.",
			filename:"LenovoPartsCSV",
			columns: [
				{ column: "ID", label: "ID" },
				{ column: "Name", label: "Name" },
				{ column: "ProductID", label: "ProductID" },
				{ column: "product.Name", label: "Product Name" },
				{ column: "Cost", label: "Cost"},
				{ column: "Price", label: "Price"},
				{ column: "Margin", label: "Margin"},
				{ column: "NewMargin", label: "NewMargin"},
				{ column: "NewNewMargin", label: "NewNewMargin"},
				{ column: "PositiveInteger", label: "PositiveInteger"},
				{ column: "SomeBoolean", label: "SomeBoolean"},
				{ column: "NewCheckbox", label: "NewCheckbox"},
				{ column: "DateTime", label: "Date", dateFormat: "YYYY-MM-DD HH:mm"},
			],

			exporttypes:[
				{label:"Simple",
					removevalues:[
						'ID'
					]
				}
			]
		}
	}





	/* 
				░█████████                               ░██                     
				░██     ░██                              ░██                     
				░██     ░██  ░███████  ░████████   ░████████  ░███████  ░██░████ 
				░█████████  ░██    ░██ ░██    ░██ ░██    ░██ ░██    ░██ ░███     
				░██   ░██   ░█████████ ░██    ░██ ░██    ░██ ░█████████ ░██      
				░██    ░██  ░██        ░██    ░██ ░██   ░███ ░██        ░██      
				░██     ░██  ░███████  ░██    ░██  ░█████░██  ░███████  ░██                                                                                                                 
	*/

	return (<FlexiGrid configuration={configuration} classes={classes} perms={perms}/>);
}

export default LenovoPartsFlexiGrid;